<template>
  <b-col>
    <template v-if="!hideName">
      <p class="mb-0"><b>{{name || 'Date'}}</b></p>
    </template>
    <p style="line-height: 1.2rem">{{ formatDate(value, 'MMM YYYY') }}</p>
  </b-col>
</template>

<script>
import formatDate from 'date-fns/format';

export default {
  name: 'DateShow',
  props: {
    name: {
      type: String,
    },
    value: {
      default: null,
    },
    backgroundColor: {
      type: String,
      default: '#eee',
    },
    hideName: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate,
  }
};
</script>



// WEBPACK FOOTER //
// src/components/profile/DateShow.vue